import envConfig from '@/config/env';
import { Connection } from '@solana/web3.js';

const connection = new Connection(envConfig.VITE_RPC_URL, 'confirmed');

export const walletSignMessage = async (message: string): Promise<{ publicKey: any; signature: Uint8Array } | null> => {
  const provider = window.solana;

  if (!provider) return null;

  const messageBytes = new TextEncoder().encode(message);
  const signedMessage = await provider.signMessage(messageBytes);

  return signedMessage;
};

export const getTransaction = (hash: string, maxRetries = 10, interval = 1000): Promise<boolean> => {
  let checkCount = 0;

  const checkTransaction = async (): Promise<boolean> => {
    try {
      const response = await connection.getTransaction(hash, {
        commitment: 'confirmed',
        maxSupportedTransactionVersion: 0,
      });

      if (response?.meta?.err === null) {
        return true;
      }

      if (checkCount >= maxRetries) {
        return false;
      }

      return false;
    } catch (error) {
      if (checkCount >= maxRetries) {
        return false;
      }
      return false;
    }
  };

  return new Promise((resolve) => {
    const intervalId = setInterval(async () => {
      checkCount++;
      const success = await checkTransaction();
      if (success || checkCount >= maxRetries) {
        clearInterval(intervalId);
        resolve(success);
      }
    }, interval);
  });
};

export default connection;
